import { MutationStatus } from 'react-query';
import { Typography } from 'web-library';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { Theme as AugmentedTheme } from '@mui/material';


import { makeStyles } from 'tss-react/mui';

interface OneTimePasswordHelperMessageProps {
  otpGenerateMutationStatus: MutationStatus;
  internationalSmsOtpFail: boolean;
  emailAddress: string;
  contactNumber: string;
  selectedTfa: number;
}

const useStyles = makeStyles()((theme) =>
({
  topSectionText: {
    paddingTop: theme.spacing(1),
  },
  bottomSectionText: {
    paddingBottom: theme.spacing(2),
  },
  errorText: {
    color: theme.color.state.stateError,
  },
  textBold: {
    fontWeight: 'bold',
  },
}));

const OneTimePasswordHelperMessage = ({
  otpGenerateMutationStatus,
  internationalSmsOtpFail,
  emailAddress,
  contactNumber,
  selectedTfa,
}: OneTimePasswordHelperMessageProps) => {
  const { t } = useTranslation();
  const { classes } = useStyles();

  if (selectedTfa === 1) {
    if (otpGenerateMutationStatus === 'loading') {
      return <></>;
    }
    if (internationalSmsOtpFail) {
      return (
        <>
          <Typography
            className={[classes.topSectionText, classes.errorText, classes.textBold].join(' ')}
            variant="body1"
          >
            {t('profile->>OneTimePasswordForm.InternationalSmsErrorMessage1')}
          </Typography>
          <Typography className={classes.errorText} variant="body1">
            {t('profile->>OneTimePasswordForm.InternationalSmsErrorMessage2')}
          </Typography>
          <Typography className={classes.bottomSectionText} variant="body1">
            {t(
              'profile->>OneTimePasswordForm.Enter the 6-digit One-Time Password (OTP) sent to your {{selectedTwoFactorOption}}.',
              {
                selectedTwoFactorOption: `email ${emailAddress}`,
              }
            )}
          </Typography>
        </>
      );
    }
  }

  return (
    <Typography
      className={[classes.topSectionText, classes.bottomSectionText].join(' ')}
      variant="body1"
    >
      {t(
        'profile->>OneTimePasswordForm.Enter the 6-digit One-Time Password (OTP) sent to your {{selectedTwoFactorOption}}.',
        {
          selectedTwoFactorOption:
            selectedTfa === 0 ? `email ${emailAddress}` : `mobile no. ${contactNumber}`,
        }
      )}
    </Typography>
  );
};

export default OneTimePasswordHelperMessage;
